import React, { Component } from "react";
import DateTime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import moment from "moment-timezone";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { asField } from "informed";
import validatehoc from "../Validator";

class DateTimePicker extends Component {
	constructor(props) {
		super(props);
		let timezone = localStorage.getItem("timezone")
			? localStorage.getItem("timezone")
			: props.user.user
			? props.user.user.timeZoneId
				? props.user.user.timeZoneId
				: moment.tz.guess()
			: moment.tz.guess();
		let zone = moment.tz.zone(timezone);
		this.state = {
			timezone,
			offset: zone.parse(this.parseDate(props.fieldState.value)),
		};
		if (props.getDateApi) {
			props.getDateApi({
				removeDate: this.removeDate,
				updateDateTime: this.updateDateTime,
				fieldApi: props.fieldApi,
			});
		}
	}

	state = {
		focused: false,
	};

	onFocus = () => {
		let { onFocus, fieldApi } = this.props;
		this.setState({ focused: true });
		if (onFocus) {
			onFocus(fieldApi);
		}
	};

	onBlur = () => {
		setTimeout(() => {
			this.setState({ focused: false });
		}, 100);
	};

	updateDateTime = newDateTime => {
		let value = "";
		if (newDateTime !== "") {
			var date = new moment(newDateTime);
			if (date.isValid()) {
				value = this.offsetToUTCDate(newDateTime.toDate());
			} else {
				value = newDateTime;
			}
		}
		this.props.fieldApi.setValue(value);
		this.props.fieldApi.setTouched(true);
	};

	timezoneList = () => {
		let timezones = [];
		if (this.props.timezones) {
			this.props.timezones.forEach(timezone => {
				timezones.push(
					<option key={timezone.id} value={timezone.id}>
						{timezone.name}
					</option>
				);
			});
		}
		return timezones;
	};

	parseDate = input => {
		if (input === "") {
			const dateString = new Date(
				moment
					.utc()
					.minutes(0)
					.seconds(0)
					.milliseconds(0)
					.toISOString()
			).toUTCString();
			return dateString;
		} else {
			try {
				return new Date(input).toUTCString();
			} catch (error) {
				return "";
			}
		}
	};

	updateTimezone = timezone => {
		localStorage.setItem("timezone", timezone);
		let zone = moment.tz.zone(timezone);
		this.setState({ timezone, offset: zone.parse(this.parseDate(this.props.value)) });
	};

	utcToOffsetDate = date => {
		var stillUtc = new Date(moment.utc(date).toISOString()).getTime();
		let offset = moment.tz.zone(this.state.timezone).parse(stillUtc);
		const local = new Date(stillUtc - offset * 60 * 1000);
		return local;
	};

	offsetToUTCDate = date => {
		var stillUtc = new Date(moment.utc(date).toISOString()).getTime();
		let offset = moment.tz.zone(this.state.timezone).utcOffset(stillUtc);
		const local = new Date(stillUtc + offset * 60 * 1000);
		return local;
	};

	removeDate = e => {
		if (e) {
			e.stopPropagation();
			e.preventDefault();
		}
		this.props.fieldApi.setValue(null);
		this.props.fieldApi.setTouched(true);
		this.onBlur();
	};

	isValidDate = current => {
		const { isValidDate } = this.props;
		if (isValidDate) {
			return isValidDate(current);
		}
		return true;
	};

	render() {
		let { props } = this;
		const { helperText, placeholder, isRequired } = props;
		const { value, error } = props.fieldState;
		const hasError = error ? " has-error" : "";
		const shouldFocus = value && value !== null;
		const hasFocus = shouldFocus ? " focus" : "";
		var displayValue = value === null ? null : this.utcToOffsetDate(this.parseDate(props.fieldState.value));
		var dateFormat = "MMMM Do YYYY"; //TODO make this globalized based on experience culture?
		var timeFormat = "h:mm:ss a";

		let dateTimeProps = {};
		if (value) {
			dateTimeProps = {
				value: displayValue,
			};
		} else {
			dateTimeProps = {
				value: null,
				//defaultValue: this.utcToOffsetDate(new Date(moment.utc().minutes(0).seconds(0).milliseconds(0).add(1, "hour").toISOString()))
			};
		}

		return (
			<div className={`datetime-input input-wrap ${hasFocus} ${hasError}`}>
				<div className={`date-timezone-picker${this.state.focused ? " has-focus" : ""}${hasError}`}>
					<div className="placeholder">
						<span className={shouldFocus ? "caption-text" : ""}>
							{isRequired && <span className="isrequired-label">*</span>}
							{placeholder} ({this.state.timezone})
						</span>
					</div>
					<div className={`coverall ${this.state.focused ? "on" : ""}`} onClick={() => this.onBlur()}></div>
					<DateTime
						id={this.id}
						{...dateTimeProps}
						onFocus={() => {
							this.onFocus();
						}}
						onBlur={() => {
							this.onBlur();
						}}
						onChange={moment => {
							this.updateDateTime(moment);
						}}
						dateFormat={dateFormat}
						timeFormat={timeFormat}
						utc
						isValidDate={this.isValidDate}
					/>
					<div className={`input-modal ${this.state.focused ? "on" : "off"}`}>
						<div className="btn btn-primary wide m-top" onClick={this.removeDate}>
							Clear Date
						</div>
					</div>
					<div className="timezone-picker">
						<div className="timezone-icon">
							<i className="fal fa-globe"></i>
						</div>
						<select
							title={`Timezone: ${this.state.timezone} (Click to Change)`}
							value={this.state.timezone ? this.state.timezone : ""}
							onChange={event => {
								this.updateTimezone(event.target.value);
							}}
							style={{ border: "none" }}
						>
							{this.timezoneList()}
						</select>
					</div>
				</div>
				<div className="row">
					<div className="col-xs-6">
						<div className="caption-text helper-message">{helperText}</div>
					</div>
					<div className="col-xs-6">
						<div className="error-message caption-text">{error ? error : ""}</div>
					</div>
				</div>
			</div>
		);
	}
}
DateTimePicker.propTypes = {
	field: PropTypes.string,
	helperText: PropTypes.string,
	onUpdate: PropTypes.func,
	value: PropTypes.any,
	timeZoneOffset: PropTypes.number,
	timezones: PropTypes.array,
	placeholder: PropTypes.string,
	timeZoneId: PropTypes.string,
	fieldState: PropTypes.object,
	user: PropTypes.object,
	fieldApi: PropTypes.object,
	isValidDate: PropTypes.func,
	getDateApi: PropTypes.func,
	onFocus: PropTypes.func,
	isRequired: PropTypes.bool,
};
function mapStateToProps(state) {
	return {
		timezones: state.controlPanel.timezones,
		user: state.user,
	};
}
const ConnectedDateTime = connect(mapStateToProps)(DateTimePicker);

const Wrapper = validatehoc(
	asField(({ fieldState, ...props }) => <ConnectedDateTime fieldState={fieldState} {...props} />)
);

export default Wrapper;
